
import store from "@/store";

const routes = [{
    path: "/operations/stocktransfer/:id",
    name: "warehousestocktransfer",
    component: () => import('@/views/main/modules/Operations/StockTransfer/StockTransfersComponent'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })

    },
    meta: {
        requiresAuth: true,
        title: 'Stock Transfers',
    }
}]

export default routes;
